import { Button, Col, Form, Input, Row, notification } from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";

const LogisticsMine = ({ match, history }) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getMine();
	}, []);

	const getMine = async () => {
		const url = api + "/logistics/mine/get/" + match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				setInitialValues({
					...initialValues,
					name: data.payload.name,
				});
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingForm(false);
		} catch (err) {
			setLoadingForm(false);
			openNotification("error", "Error", "Error while trying to get origin");
			console.error(err.message);
			return null;
		}
	};

	const updateMine = async (data) => {
		const mine = {
			name: data.name,
		};

		try {
			let url = api + "/logistics/mine/update/" + match.params.id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.patch(url, mine);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					history.push("/logistics/origin/list");
				}, 2000);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to update origin");
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		updateMine(values);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col>
						<Button type="primary" htmlType="submit" loading={loading}>
							Save
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Layout
			title="Logistics Mine"
			description="Edit Logistics Mine"
			type="small"
		>
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default LogisticsMine;
